@import (reference) '../../constants/spacing.module.less';

.shop-promise-tag {
  background: var(--shop-promise--primary-color);
}

.shop-promise-logo {
  height: 20px;
}
